module.exports = __webpack_public_path__ + "static/media/crypto.1b1f745c.png";